var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-socials--icon__wrapper",attrs:{"ach-tooltip":_vm.name}},[(_vm.link)?_c('a',{staticClass:"c-socials--icon",on:{"click":_vm.openLink}},[_c('i',{class:_vm.icon})]):_c('a',{staticClass:"c-socials--icon",on:{"click":_vm.openAssociatedModal}},[_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }